import * as React from 'react';

import { CheckmarkLine, IntermediateLine } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  readonly?: boolean;
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-[3px] focus-visible:outline-[2px] focus-visible:outline-offset-1 focus-visible:outline-action-focusBorder data-[state=checked]:bg-tertiary-main data-[state=indeterminate]:bg-tertiary-main data-[state=unchecked]:border data-[state=unchecked]:border-icon-primary',
        props.disabled &&
          'data-[state=checked]:bg-action-disabled01 data-[state=indeterminate]:bg-action-disabled01 data-[state=unchecked]:border-action-disabled01',
        props.readonly &&
          'pointer-events-none data-[state=checked]:bg-action-disabled02 data-[state=indeterminate]:bg-action-disabled02 data-[state=unchecked]:border-action-disabled02',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex h-4 w-4 items-center justify-center">
        {props.checked === 'indeterminate' ? (
          <IntermediateLine className="h-4 w-4 fill-greyscale-white p-1" />
        ) : (
          <CheckmarkLine className="h-4 w-4 fill-greyscale-white p-1" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

function CheckboxIcon({
  className,
  checkedIcon,
  icon,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  readonly?: boolean;
  checkedIcon: React.ReactNode;
  icon: React.ReactNode;
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'group/checkbox flex min-h-4 min-w-4 shrink-0 items-center justify-center focus-visible:rounded-[3px] focus-visible:outline-[2px] focus-visible:outline-offset-1 focus-visible:outline-action-focusBorder data-[state=checked]:fill-tertiary-main data-[state=unchecked]:fill-icon-primary',
        props.disabled &&
          'data-[state=checked]:fill-action-disabled01 data-[state=unchecked]:border-action-disabled01',
        props.readonly &&
          'pointer-events-none data-[state=checked]:fill-action-disabled02 data-[state=unchecked]:border-action-disabled02',
        className,
      )}
      {...props}
    >
      <span className="group-data-[state=checked]/checkbox:hidden">{icon}</span>
      <span className="group-data-[state=unchecked]/checkbox:hidden">
        {checkedIcon}
      </span>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox, CheckboxIcon };
